export default __webpack_public_path__ + "static/media/issue-closed.141f005b.svg";